import {Fragment, UUID} from '@nh/angular-tses';
import {DepartureInformationType} from '../departure/departure-information/departure-information-type';
import {DASFragmentType} from './das-fragment-type';

/**
 * A class representing a Departure Information Fragment used for displaying form field information captured in
 * the Departure Information section.
 *
 * @field departureInformationType {DepartureInformationType}   The type of departure information
 */
export class DepartureInformationFragment extends Fragment {
  /**
   * Static helper to create a departure information fragment of a given type.
   *
   * @param type {DepartureInformationType}       The type of departure information type
   * @returns    {DepartureInformationFragment}   The Departure Information Fragment object
   */
  public static empty(type: DepartureInformationType): DepartureInformationFragment {
    return new DepartureInformationFragment(null, '', type);
  }

  constructor(id: UUID, value: string = '', public departureInformationType: DepartureInformationType) {
    super(id, DASFragmentType.INFORMATION, [], value);
  }

  /**
   * @inheritDoc
   */
  public split(offset: number): DepartureInformationFragment {
    return null;
  }

  /**
   * @override
   */
  public get value(): string {
    return this._value;
  }

  /**
   * @override
   */
  public set value(value: string) {
    this._value = value;
  }

  /**
   * Returns true if this fragment has one of the passed types.  Also returns true if
   * passed no arguments.
   *
   * @param types {DepartureInformationType[]} The types
   * @returns     {boolean}                    True if one of these types
   */
  public isInformationType(...types: DepartureInformationType[]) {
    return types.length === 0 || types.indexOf(this.departureInformationType) >= 0;
  }
}

/**
 * Deserialiser function for Departure Information Fragments.
 *
 * @param json {any}                            JSON object to deserialise
 * @returns    {DepartureInformationFragment}   Deserialised Departure Information Fragment Object
 */
export function deserialiseDepartureInformationFragment(json: any): DepartureInformationFragment {
  return new DepartureInformationFragment(UUID.orThrow(json.id), json.value, json.departureInformationType);
}
